import qs from 'qs';
import axios from 'axios';
import client from './rest/AdminClient';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const getLocations = (params) => {
    const query = params || {};
    const queryString = qs.stringify(query);
    return client({
        method: 'GET',
        path: `/admin/api/v2/locations?${queryString}`,
    });
};
const findLocations = (params) => {
    const query = params || {};
    const queryString = qs.stringify(query);
    return client({
        method: 'GET',
        path: `/admin/api/v2/locations?${queryString}`,
    });
};
const getLocation = (id) => {
    return client({
        method: 'GET',
        path: `/admin/api/v2/locations/${id}`,
    });
};
const createLocation = (location) => {
    return client({
        method: 'POST',
        path: '/admin/api/v2/locations',
        entity: JSON.stringify(location),
    });
};
export const updateLocation = (location) => {
    return client({
        method: 'PATCH',
        path: `/admin/api/v2/locations/${location._id}`,
        entity: JSON.stringify(location),
    });
};
const addLocationAlias = (id, alias) => {
    return client({
        method: 'POST',
        path: `/api/v2/locations/${id}/aliases/${alias}`,
    });
};
const deleteLocationAlias = (id, alias) => {
    return client({
        method: 'DELETE',
        path: `/api/v2/locations/${id}/aliases/${alias}`,
    });
};
export const deleteLocation = (id) => {
    return client({
        method: 'DELETE',
        path: `/api/v2/locations/${id}`,
    });
};
const getLocationPairs = (params) => {
    const query = params || {};
    const queryString = qs.stringify(query);
    return client({
        method: 'GET',
        path: `/admin/api/locations/pairs?${queryString}`,
    });
};
const createLocationPair = (data) => {
    return client({
        method: 'POST',
        entity: JSON.stringify(data),
        path: '/admin/api/locations/pairs',
    });
};
const updateLocationPair = (id, updates) => {
    return client({
        method: 'PUT',
        path: `/admin/api/locations/pairs/${id}`,
        entity: JSON.stringify(updates),
    });
};
const removeLocationPair = (id) => {
    return client({
        method: 'DELETE',
        path: `/admin/api/locations/pairs/${id}`,
    });
};
const removeLocation = (id) => {
    return client({
        method: 'DELETE',
        path: `/admin/api/v2/locations/${id}`,
    });
};
const zipToCityState = (zip) => {
    const options = {
        method: 'get',
        url: `${LOCATION_HOST}/location/ziptocity?zip=${zip}`,
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': LOCATION_KEY,
        },
    };
    return axios(options);
};
const getCustomZones = (query) => {
    let url = `${LOCATION_HOST}/location/zone/custom?`;
    if (query) {
        url = `${LOCATION_HOST}/location/zone/custom?${query}`;
    }
    const options = {
        method: 'get',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': LOCATION_KEY,
        },
    };
    return axios(options);
};
export default {
    getLocations(query) {
        getLocations(query).then((response) => {
            const locations = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_LOCATION_SEARCH,
                locations,
            });
        }, (response) => {
            console.error('Failed to retrieve locations: ', response);
        });
    },
    findLocations(query) {
        findLocations(query).then((response) => {
            const locations = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_LOCATION_SEARCH,
                locations,
            });
        }, (response) => {
            console.error('Failed to retrieve locations: ', response);
        });
    },
    getLocations(query) {
        getLocations(query).then((response) => {
            const locations = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_LOCATIONS_LIST,
                locations,
            });
        }, (response) => {
            console.error('Failed to retrieve locations: ', response);
        });
    },
    getLocation(id) {
        getLocation(id).then((response) => {
            AdminServerActionCreators.receiveLocation(response.entity);
        }, (response) => {
            console.error('Failed to retrieve location: ', response);
        });
    },
    createLocation(data) {
        createLocation(data).then((response) => {
            const location = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_LOCATION,
                location,
            });
        }, (response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.CREATE_LOCATION_FAIL,
                entity,
            });
        });
    },
    updateLocation(location) {
        updateLocation(location).then((response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_LOCATION,
                entity,
            });
        }, (response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.SAVE_LOCATION_FAIL,
                entity,
            });
        });
    },
    addLocationAlias(id, alias) {
        addLocationAlias(id, alias).then((response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_LOCATION,
                location: { location: entity },
            });
        }, (response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.SAVE_LOCATION_FAIL,
                entity,
            });
        });
    },
    deleteLocationAlias(id, alias) {
        deleteLocationAlias(id, alias).then((response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_LOCATION,
                location: { location: entity },
            });
        }, (response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.SAVE_LOCATION_FAIL,
                entity,
            });
        });
    },
    getLocationPairs(params) {
        getLocationPairs(params).then((response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_LOCATION_PAIRS,
                entity,
            });
        }, (response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_LOCATION_PAIRS_FAIL,
                entity,
            });
        });
    },
    createLocationPair(params) {
        createLocationPair(params).then((response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_CREATE_LOCATION_PAIR,
                entity,
            });
        }, (response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_CREATE_LOCATION_PAIRS_FAIL,
                entity,
            });
        });
    },
    updateLocationPair(id, params) {
        updateLocationPair(id, params).then((response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_UPDATE_LOCATION_PAIR,
                entity,
            });
        }, (response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_LOCATION_PAIR_FAIL,
                entity,
            });
        });
    },
    removeLocationPair(id) {
        removeLocationPair(id).then((response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_DELETE_LOCATION_PAIR,
                entity,
            });
        }, (response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_DELETE_LOCATION_PAIR_FAIL,
                entity,
            });
        });
    },
    removeLocation(id) {
        removeLocation(id).then((response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_DELETE_LOCATION,
                entity,
            });
        }, (response) => {
            const entity = response.entity;
            AdminAppDispatcher.handleServerAction({
                type: ActionTypes.RECEIVE_DELETE_LOCATION_FAIL,
                entity,
            });
        });
    },
    zipToCityState(zip) {
        return zipToCityState(zip)
            .then(function (res) {
            if (res && res.data) {
                return res.data;
            }
            throw new Error('location service API error');
        })
            .catch(function (err) {
            console.log(err.stack || err);
            return err;
        });
    },
    getCustomZones(query) {
        return getCustomZones(query)
            .then(function (res) {
            if (res && res.data) {
                return res.data;
            }
            throw new Error('location service API error');
        })
            .catch(function (err) {
            console.log(err.stack || err);
            return err;
        });
    },
};
